<div *ngIf="articles && !loading" data-test="articles">
    <div *ngFor="let article of articles; let i = index">
        <div *ngIf="loading && currentIndex <= i" class="article-skeleton">
            <!-- Skeleton loading placeholders -->
            <div class="article-url-placeholder skeleton-placeholder"></div>
            <div class="article-url-source-placeholder skeleton-placeholder"></div>
            <div class="article-title-placeholder skeleton-placeholder"></div>
            <div class="article-para-placeholder skeleton-placeholder"></div>
            <div class="article-more-content-placeholder skeleton-placeholder"></div>
        </div>
        <div *ngIf="!loading || currentIndex > i" class="article" [attr.id]="'article-' + i" [attr.data-test]="'article-' + i">
            <!-- Article details -->
            <div class="article-url">
                <a class="custom-link" href="{{ article.url }}" [attr.id]="'article-url-' + i" [attr.data-test]="'article-url-' + i" target="_blank">{{ article.domain }}</a>
            </div>
            <div class="article-url-source">{{ article.publishedDate }}</div>
            <div class="article-title" title="{{ article.title }}" [attr.id]="'article-title-' + i" [attr.data-test]="'article-title-' + i">{{ article.title }}</div>
            <div class="article-para" [attr.id]="'article-paragraph-' + i" [attr.data-test]="'article-paragraph-' + i">
                <div class="article-content" #articleContent [@expandCollapse]="isContentExpanded[i] ? 'expanded' : 'collapsed'">
                    <!-- {{ article.paragraphs }} -->
                    <div *ngIf="gyanType == 'rapid'">
                        <div *ngIf="article.paragraphs?.length > 0" class="position-relative">
                            <div *ngFor="let sentenseGroup of article.paragraphs; let j = index">
                                <p [ngClass]="{ 'highlighted-summary': article.articleId === currentArticleId && j === selectedParaIndex }">
                                    <span *ngFor="let sentence of sentenseGroup.sentences">
                                        <!-- The below span will be displayed if there is sentenceId for the paragraph -->
                                        <span
                                            *ngIf="!isClickBack && sentence.sentenceRecordId"
                                            [ngClass]="{
                                                'highlighted-summary': isSentenceHighlighted(sentence.sentenceRecordId) || sentence.sentenceRecordId === currentSelectedArticleId,
                                            }"
                                            (click)="
                                                !isContentExpanded[i] ? toggleContent(i, article.articleId) : loadArticleLongStory(article.articleId, sentence.sentenceRecordId);
                                                selectedParaIndex = j
                                            "
                                            [attr.data-test]="'article-para-' + i + '-' + j"
                                            [attr.id]="sentence.sentenceRecordId"
                                            >{{ sentence.sentence }}</span
                                        >
                                        <!-- The below span will be displayed if there is no sentenceId for the paragraph -->
                                        <span
                                            *ngIf="!isClickBack && !sentence.sentenceRecordId"
                                            [ngClass]="{
                                                'highlighted-summary': isSentenceHighlighted(sentence.sentenceRecordId) || sentence.sentenceRecordId === currentSelectedArticleId,
                                            }"
                                            [attr.id]="sentence.sentenceRecordId"
                                            >{{ sentence.sentence }}</span
                                        >
                                        <!-- The below span will be displayed only for advanced query clickback -->
                                        <span
                                            *ngIf="isClickBack"
                                            [innerHTML]="sentence.sentence"
                                            (click)="
                                                !isContentExpanded[i] ? toggleContent(i, article.articleId) : loadArticleLongStory(article.articleId, sentence.sentenceRecordId);
                                                selectedParaIndex = j
                                            "
                                            [attr.data-test]="'article-para-' + i + '-' + j"
                                        ></span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="gyanType == 'gyan'">
                        <ng-container
                            *ngTemplateOutlet="
                                HierarchySummary;
                                context: {
                                    $implicit: article.contextualSummary,
                                    articleId: article.id,
                                    i: i,
                                }
                            "
                        >
                        </ng-container>
                    </div>
                    <div *ngIf="gyanType == 'rapid' && article.paragraphs === null">
                        {{ 'Article Summary Not Generated.' }}
                    </div>
                    <div *ngIf="gyanType == 'gyan' && article.contextualSummary.length == 0">
                        {{ 'Article Summary Not Generated.' }}
                    </div>
                </div>
                <div [ngClass]="{ 'overlay-article': !isContentExpanded[i] }"></div>
                <!-- class="overlay-article" -->
            </div>
            <div
                class="article-skg-content"
                [attr.id]="'article-graph-' + i"
                [attr.data-test]="'article-graph-' + i"
                (click)="loadArticleNetworkGraph(article.articleId, article.title, '')"
                *ngIf="gyanType === 'rapid'"
            >
                <img
                    *ngIf="article.articleId === currentClickedArticleId"
                    src="./../../../assets/icons/icon-graph-active-hover.png"
                    alt="Knowledge Graph"
                    title="Knowledge Graph"
                />
                <img *ngIf="article.articleId !== currentClickedArticleId" src="./../../../assets/icons/icon-graph.svg" alt="Knowledge Graph" title="Knowledge Graph" />
            </div>
            <div
                class="article-skg-content"
                [attr.id]="'article-graph-' + i"
                [attr.data-test]="'article-graph-' + i"
                (click)="loadArticleNetworkGraph(article.id, article.title, article.networkRootId)"
                *ngIf="gyanType === 'gyan'"
            >
                <img *ngIf="article.id === currentClickedArticleId" src="./../../../assets/icons/icon-graph-active-hover.png" alt="Knowledge Graph" title="Knowledge Graph" />
                <img *ngIf="article.id !== currentClickedArticleId" src="./../../../assets/icons/icon-graph.svg" alt="Knowledge Graph" title="Knowledge Graph" />
            </div>
            <div class="article-more-content" [attr.id]="'article-toggle-' + i" [attr.data-test]="'article-toggle-' + i" (click)="toggleContent(i, article.id)">
                <fa-icon class="float-end" [ngClass]="isContentExpanded[i] ? 'highlighted-text' : ''" [icon]="isContentExpanded[i] ? faAngleUp : faAngleRight"></fa-icon>
            </div>
            <div class="overlay"></div>
            <div class="clear"></div>
        </div>
    </div>
</div>

<div *ngIf="loading || !articles">
    <div class="article-skeleton">
        <div class="article-url-placeholder skeleton-placeholder"></div>
        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
        <div class="article-title-placeholder skeleton-placeholder"></div>
        <div class="article-para-placeholder skeleton-placeholder"></div>
        <div class="article-more-content-placeholder skeleton-placeholder"></div>
    </div>
    <div class="article-skeleton">
        <div class="article-url-placeholder skeleton-placeholder"></div>
        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
        <div class="article-title-placeholder skeleton-placeholder"></div>
        <div class="article-para-placeholder skeleton-placeholder"></div>
        <div class="article-more-content-placeholder skeleton-placeholder"></div>
    </div>
    <div class="article-skeleton">
        <div class="article-url-placeholder skeleton-placeholder"></div>
        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
        <div class="article-title-placeholder skeleton-placeholder"></div>
        <div class="article-para-placeholder skeleton-placeholder"></div>
        <div class="article-more-content-placeholder skeleton-placeholder"></div>
    </div>
    <div class="article-skeleton">
        <div class="article-url-placeholder skeleton-placeholder"></div>
        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
        <div class="article-title-placeholder skeleton-placeholder"></div>
        <div class="article-para-placeholder skeleton-placeholder"></div>
        <div class="article-more-content-placeholder skeleton-placeholder"></div>
    </div>
    <div class="article-skeleton">
        <div class="article-url-placeholder skeleton-placeholder"></div>
        <!-- <div class="article-url-source-placeholder skeleton-placeholder"></div> -->
        <div class="article-title-placeholder skeleton-placeholder"></div>
        <div class="article-para-placeholder skeleton-placeholder"></div>
        <div class="article-more-content-placeholder skeleton-placeholder"></div>
    </div>
    <div
        [ngClass]="{
            'no-article-message-mobile': isMobile,
            'no-article-message': !isMobile && gyanType === 'rapid',
            'no-article-message-gyan': !isMobile && gyanType === 'gyan',
            'no-article-message-gyan-mobile': isMobile && gyanType === 'gyan',
        }"
        *ngIf="gyanType === 'rapid' && (articleNotAvailable || articles.length === 0)"
    >
        Articles not found
    </div>
    <div
        class="d-flex"
        [ngClass]="{
            'loading-article-message-mobile': isMobile && gyanType === 'rapid',
            'loading-article-message': !isMobile && gyanType === 'rapid',
            'loading-article-message-gyan': !isMobile && gyanType === 'gyan',
            'loading-article-message-gyan-mobile': isMobile && gyanType === 'gyan',
        }"
        *ngIf="gyanType === 'rapid' && !articleNotAvailable && !(articleNotAvailable || articles.length === 0)"
    >
        <div class="padding-summary">Loading Articles</div>
        <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
    </div>
    <div
        [ngClass]="{
            'no-article-message-mobile': isMobile,
            'no-article-message': !isMobile && gyanType === 'rapid',
            'no-article-message-gyan': !isMobile && gyanType === 'gyan',
            'no-article-message-gyan-mobile': isMobile && gyanType === 'gyan',
        }"
        *ngIf="gyanType === 'gyan' && articleNotAvailable"
    >
        Articles not found
    </div>
    <div
        class="d-flex"
        [ngClass]="{
            'loading-article-message-mobile': isMobile && gyanType === 'rapid',
            'loading-article-message': !isMobile && gyanType === 'rapid',
            'loading-article-message-gyan': !isMobile && gyanType === 'gyan',
            'loading-article-message-gyan-mobile': isMobile && gyanType === 'gyan',
        }"
        *ngIf="gyanType === 'gyan' && !articleNotAvailable"
    >
        <div class="padding-summary">Loading Articles</div>
        <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
    </div>
</div>
<ng-template #HierarchySummary let-summaryList let-articleId="articleId" let-i="i">
    <ng-container>
        <div *ngFor="let summary of summaryList; let sumInd = index">
            <div class="d-flex">
                <div *ngIf="summary.nextLevel" (click)="$event.stopPropagation(); expandCollapseIconClicked(summary)">
                    <div *ngIf="!summary.isExpanded" title="Expand" style="padding-right: 10px">
                        <fa-icon [icon]="faAngleRight"></fa-icon>
                    </div>
                    <div *ngIf="summary.isExpanded" title="Collapse" style="padding-right: 10px">
                        <fa-icon class="highlighted-text" [icon]="faAngleDown"></fa-icon>
                    </div>
                </div>
                <p class="article-para" [attr.id]="'article-para-' + i + '-' + sumInd" [attr.data-test]="'article-para-' + i + '-' + sumInd">
                    <span
                        [innerHTML]="summary.summaryText"
                        [ngClass]="{
                            'highlighted-summary': isSentenceHighlighted(summary.paraId) || summary.paraId === currentSelectedArticleId,
                        }"
                        (click)="!isContentExpanded[i] ? toggleContent(i, articleId) : loadArticleLongStory(articleId, summary.paraId)"
                    ></span>
                </p>
            </div>

            <div *ngIf="summary.nextLevel && summary.isExpanded" style="margin-left: 2rem">
                <ng-container
                    *ngTemplateOutlet="
                        HierarchySummary;
                        context: {
                            $implicit: summary.children,
                            articleId: articleId,
                            i: i,
                        }
                    "
                >
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>

<!-- <div *ngIf="article.contextualSummary.length > 0">
    <div *ngFor="let summary of article.contextualSummary">
        {{summary.summaryText}}
    </div>
 </div> -->
